import makeStyles from '@mui/styles/makeStyles';
import Slider from "@mui/material/Slider";
import {isEmpty} from 'lodash';
import moment from "moment";
import React from "react";
import {useTranslation} from "react-i18next";
import {color, font, type} from "common/tokens";

const useStyles = makeStyles({
  group: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  header: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 8,
  },
  label: {
    ...type.meta,
    color: color.TEXT,
    margin: 0,
  },
  clear: {
    ...type.meta,
    fontWeight: font.REGULAR,
    color: color.TEXT_SUBTLE,
    appearance: 'none',
    background: 'none',
    border: 'none',
    padding: 0,
    marginLeft: 'auto',
    cursor: 'pointer',
  },
  range: {
    ...type.meta,
    fontWeight: font.REGULAR,
    color: color.TEXT_MUTED,
    margin: 0,
  },
  rail: {
    backgroundColor: color.DIVIDER,
  },
  track: {
    backgroundColor: color.ACCENT,
  },
  thumb: {
    backgroundColor: color.ACCENT,
  },
});

const getDates = (startDate, endDate) => {
  let dates = [];

  let currDate = moment(startDate).startOf('day');
  let lastDate = moment(endDate).startOf('day');

  while (currDate.add(1, 'days').diff(lastDate) < 0) {
    dates.push(currDate.clone().toDate());
  }
  return dates;
};

const formatDate = date => moment(date).format('DD/MM/YY');

const TimeLineFilter = ({setFeedFilter, filterValue: {date, lastDate, firstDate}}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  const fDate = isEmpty(firstDate) ? new Date(2020, 0, 1) : new Date(firstDate);
  const tDate = isEmpty(lastDate) ? new Date() : new Date(lastDate);

  const dates = getDates(fDate, tDate);
  let fVal = 0;
  let tVal = dates.length;

  if (!isEmpty(date)) {
    fVal = date.fromVal;
    tVal = date.toVal;
  }

  const [value, setValue] = React.useState([fVal, tVal]);

  const setDateRange = value => {
    const from = value[0];
    const to = value[1];
    setFeedFilter("date", {
      fromDate: formatDate(dates[from]),
      fromVal: from,
      toDate: formatDate(dates[to]),
      toVal: to,
    });
  };

  return (
    <div className={classes.group}>
      <div className={classes.header}>
        <p className={classes.label}>{t('timeline')}</p>
        <button type={'button'} className={classes.clear} onClick={() => setValue([0, dates.length])}>
          {t('clear')}
        </button>
      </div>
      <p className={classes.range}>
        {`${moment(dates[value[0]]).format('MMM D')} - ${moment(dates[value[1]]).format('MMM D')}`}
      </p>
      <Slider
        value={value}
        onChange={(event, newValue) => setValue(newValue)}
        onChangeCommitted={() => setDateRange(value)}
        max={dates.length}
        classes={{rail: classes.rail, track: classes.track, thumb: classes.thumb}}
      />
    </div>
  );
};

export default TimeLineFilter;
